import React from 'react';
import dynamic from 'next/dynamic';

import { useTranslations } from 'hooks/useTranslations';
import {
  Wrapper,
  ShieldContainer,
  GooglePoliticsAndTermsContainer,
  SealsContainer,
} from './styles';

const DsTypography = dynamic(() => import('componentsV2/DS/Typography'), {
  ssr: false,
});

const DsIcon = dynamic(() => import('componentsV2/DS/Icon'), {
  ssr: false,
});

function SecurityFooter({
  showShieldText = true,
  showSeals = false,
  recaptchaEnterprise = false,
  dataCy,
}) {
  const { getSecurityText } = useTranslations();

  return (
    <Wrapper>
      {showShieldText && (
        <ShieldContainer data-cy={`@${dataCy}/security-place-message`}>
          <DsIcon icon="shield_check" size="small" />
          <DsTypography component="paragraph" size="small">
            {getSecurityText('secureEnvironment')}
          </DsTypography>
        </ShieldContainer>
      )}
      <GooglePoliticsAndTermsContainer
        data-cy={`@${dataCy}/recaptcha-sucurity-message`}
      >
        <DsTypography component="paragraph" size="small" color="neutral-high">
          {getSecurityText(
            recaptchaEnterprise
              ? 'recaptchaMessageEnterprise'
              : 'recaptchaMessage'
          )}{' '}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            {getSecurityText('privacyPolicy')}
          </a>{' '}
          {getSecurityText('andText')}{' '}
          <a
            href="https://policies.google.com/terms"
            target="_blank"
            rel="noreferrer"
          >
            {getSecurityText('termsOfService')}
          </a>{' '}
          {getSecurityText('googleTerms')}
        </DsTypography>
      </GooglePoliticsAndTermsContainer>
      {showSeals && (
        <SealsContainer>
          <img src="/static/sectigo-seal.png" alt="sectigo seal" />
          <img src="/static/cloudflare-seal.png" alt="cloudflare seal" />
        </SealsContainer>
      )}
    </Wrapper>
  );
}
export default SecurityFooter;
